import { render, staticRenderFns } from "./CreditDetails.vue?vue&type=template&id=5a08ffc3&scoped=true&"
import script from "./CreditDetails.vue?vue&type=script&lang=js&"
export * from "./CreditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08ffc3",
  null
  
)

export default component.exports